<div class="bill-account-terms pad-10">
  <ds-billing-terms [partnerData]="termsPartnerData$ | async"> </ds-billing-terms>
  <div class="row bill-account-terms margin-top-20">
    <button ds-button type="button" (click)="back()">Back</button>
  </div>
</div>
